"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var directus_const_1 = require("./directus.const");
/**
 * DirectusService
 * @class
 */
var DirectusService = /** @class */ (function () {
    function DirectusService() {
    }
    /**
     * Returns a list of Countries
     * @returns {Promise<GetCountriesResponse[]>}
     */
    DirectusService.prototype.getCountries = function (customBaseHost, headers) {
        var url = directus_const_1.DIRECTUS_ENDPOINTS.getCountries.replace('{{customBaseHost}}', customBaseHost);
        return axios_client_service_1.axiosClientInstance.get(url, {}, headers);
    };
    /**
     * Returns a list of Cities
     * @param {string} country
     * @returns {Promise<GetCitiesResponse[]>}
     */
    DirectusService.prototype.getCities = function (customBaseHost, headers, country) {
        var url = directus_const_1.DIRECTUS_ENDPOINTS.getCities.replace('{{customBaseHost}}', customBaseHost);
        return axios_client_service_1.axiosClientInstance.get(url, {
            'filter[country_code]': country,
        }, headers);
    };
    /**
     * Returns the articles from a city.
     * @param {number} city
     * @param {string} fields
     * @returns {Promise<GetArticlesResponse[]>}
     */
    DirectusService.prototype.getArticles = function (customBaseHost, headers, city, fields) {
        var url = directus_const_1.DIRECTUS_ENDPOINTS.getArticles.replace('{{customBaseHost}}', customBaseHost);
        return axios_client_service_1.axiosClientInstance.get(url, {
            'filter[city]': city,
            fields: fields,
        }, headers);
    };
    /**
     * Returns the sections of the how-it-works of a city
     * @param {number} city
     * @param {string} fields
     * @returns {Promise<GetHowItWorksArticlesResponse[]>}
     */
    DirectusService.prototype.getHowItWorksArticles = function (customBaseHost, headers, city, fields) {
        var url = directus_const_1.DIRECTUS_ENDPOINTS.getHowItWorksArticles.replace('{{customBaseHost}}', customBaseHost);
        return axios_client_service_1.axiosClientInstance.get(url, {
            'filter[city]': city,
            fields: fields,
        }, headers);
    };
    /**
     * Returns the sections of the how-it-works of a city
     * @param {number} city
     * @param {string} fields
     * @returns {Promise<GetContactInformationsResponse[]>}
     */
    DirectusService.prototype.getContactInformations = function (customBaseHost, headers, city, fields) {
        var url = directus_const_1.DIRECTUS_ENDPOINTS.getContactInformations.replace('{{customBaseHost}}', customBaseHost);
        return axios_client_service_1.axiosClientInstance.get(url, {
            'filter[city]': city,
            fields: fields,
        }, headers);
    };
    /**
     * Returns the sections of the about-us section
     * @param {number} city
     * @param {string} fields
     * @returns {Promise<GetAboutUsArticlesResponse[]>}
     */
    DirectusService.prototype.getAboutUsArticles = function (customBaseHost, headers, city, fields) {
        var url = directus_const_1.DIRECTUS_ENDPOINTS.getAboutUsArticles.replace('{{customBaseHost}}', customBaseHost);
        return axios_client_service_1.axiosClientInstance.get(url, {
            'filter[city]': city,
            fields: fields,
        }, headers);
    };
    return DirectusService;
}());
/**
 * DirectusService Class Instance
 * @namespace
 */
exports.directus = new DirectusService();
